import Dictionary from '@/types/dictionary';
import notification from '../notification';

export enum SUBSCRIPTION_STATUS {
  IN_TRIAL = 'in_trial',
}

export enum SUBSCRIPTION_PLAN {
  ESSENTIAL = 'ESSENTIAL',
  PRO_MONTHLY = 'PRO_MONTHLY',
  PRO_ANNUAL = 'PRO_ANNUAL',
}

type ChargebeeInstance = {
  setPortalSession: (session: any) => Promise<void>;
  createChargebeePortal: () => any;
  logout: () => void;
  openCheckout: (options: any) => void;
  getPortalSections: () => Dictionary<string>;
};

let instance: ChargebeeInstance;
let PORTAL_SECTIONS: Dictionary<string> = {};

const init = () => {
  const site = import.meta.env.REACT_APP_CHARGEBEE_SITE;
  if (!site) {
    return;
  }

  const win = window as any;
  instance = win.Chargebee.init({ site });
  PORTAL_SECTIONS = win.Chargebee.getPortalSections();
};

const getInstance = () => instance;

const getPortalSections = () => PORTAL_SECTIONS;

const openPortal = (session: any, options?: any) => {
  if (!instance) {
    return notification.errorFromKey('CHARGEBEE_ERROR');
  }

  instance.setPortalSession(session);
  instance.createChargebeePortal().open(
    {
      close: instance.logout.bind(instance),
    },
    options,
  );
};

export default {
  init,
  getInstance,
  openPortal,
  getPortalSections,
};
